<template>
  <div id="press_page" v-if="item && item.communist_pdf_path != ''" style="text-align:center;">

      <div class="download_buttons">
        <a v-if="item.communist_doc > 0" class="btn_down" :href="'https://www.mysong.co.il/download/press/' + item.id + '?type=press_doc'"><i class="material-icons dp48">file_download</i> WORD</a>
        <a v-if="item.communist_pdf > 0" class="btn_down" :href="'https://www.mysong.co.il/download/press/' + item.id + '?type=press_pdf'"><i class="material-icons dp48">file_download</i> PDF</a>
      </div>

      <iframe :src="item.communist_pdf_path" frameborder="0" id="pdf_iframe" style="max-width: 100%; margin:0 auto;"></iframe>
  </div>
</template>

<script>
export default {
  props: ["widgets", "item"],
  created(){
    
    
  }
}
</script>
